import { render, staticRenderFns } from "./LoveGift.vue?vue&type=template&id=45d0f5a0&scoped=true&"
import script from "./LoveGift.vue?vue&type=script&lang=js&"
export * from "./LoveGift.vue?vue&type=script&lang=js&"
import style0 from "./LoveGift.vue?vue&type=style&index=0&id=45d0f5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0f5a0",
  null
  
)

export default component.exports